module.exports = __webpack_public_path__ + "580de0f98295fc33b2ee5427b98a45bb.svg";